/**
 * GoalTabs — goal-set tabs (First value / Monetized / Ads-ready /
 * Full production) with done/total chips. Filtering itself lives in the page;
 * this component only renders and reports tab selection.
 */

import React from 'react';
import Chip from '@mui/material/Chip';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Box from '@mui/material/Box';
import { LAUNCH_READINESS_TEST_IDS } from '../testIds';
import type { LaunchGoalSet, LaunchMilestone } from '../types/launchReadiness.types';
import { GOAL_LABELS, GOAL_ORDER, countGoalProgress } from '../utils/goalMilestones';

export interface GoalTabsProps {
  milestones: LaunchMilestone[];
  value: LaunchGoalSet;
  onChange: (goal: LaunchGoalSet) => void;
}

export const GoalTabs: React.FC<GoalTabsProps> = ({ milestones, value, onChange }) => {
  return (
    <Tabs
      value={value}
      onChange={(_event, next: LaunchGoalSet) => onChange(next)}
      sx={{ borderBottom: '1px solid', borderColor: 'divider', mb: 2 }}
    >
      {GOAL_ORDER.map((goal) => {
        const { done, total } = countGoalProgress(milestones, goal);
        return (
          <Tab
            key={goal}
            value={goal}
            data-testid={LAUNCH_READINESS_TEST_IDS.goalTab(goal)}
            label={(
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                {GOAL_LABELS[goal]}
                <Chip size="small" variant="outlined" label={`${done}/${total}`} />
              </Box>
            )}
          />
        );
      })}
    </Tabs>
  );
};

export default GoalTabs;
